export const PercentageSpendTypes = ['MARGIN', 'MARKUP']
export const DspAdvertisingSpendTypeOpts = [
  { text: 'Flat CPC', value: 'FLAT_CPC' },
  { text: 'Flat CPM', value: 'FLAT_CPM' },
  { text: 'Margin', value: 'MARGIN' },
  { text: 'Markup', value: 'MARKUP' }
] as const
